import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <h1 className="page-title">ABOUT NQC</h1>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is a trusted partner in certification services, 
                located in the United States. We offer top-tier certification solutions, including ISO, 
                CE, Testing, Auditing, and Evaluation services.
              </p>
              <p>
                Our mission is to help organizations achieve the highest standards of excellence and 
                meet regulatory requirements. With years of experience and a team of certified professionals, 
                we provide comprehensive certification services tailored to your business needs.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Our Services:</h2>
            <div className="services-list">
              <div className="service-item">
                <h3 className="service-title">ISO Certification</h3>
                <p className="service-description">
                  Comprehensive ISO certification services for various management systems including 
                  Quality Management (ISO 9001), Environmental Management (ISO 14001), and more.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">CE Marking</h3>
                <p className="service-description">
                  CE marking services to ensure your products comply with European Union regulations 
                  and can be legally sold in the European Economic Area.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">Testing Services</h3>
                <p className="service-description">
                  Comprehensive testing services to verify product quality, safety, and compliance 
                  with industry standards and regulations.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">Auditing</h3>
                <p className="service-description">
                  Professional auditing services to assess your organization's compliance with 
                  quality standards and regulatory requirements.
                </p>
              </div>
              <div className="service-item">
                <h3 className="service-title">Evaluation</h3>
                <p className="service-description">
                  Detailed evaluation services to assess your products, processes, and systems 
                  against applicable standards and best practices.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC?</h2>
            <div className="why-choose-list">
              <div className="why-choose-item">
                <h3 className="why-choose-title">Expertise and Experience</h3>
                <p className="why-choose-description">
                  Our team consists of certified professionals with extensive experience in certification 
                  services across various industries.
                </p>
              </div>
              <div className="why-choose-item">
                <h3 className="why-choose-title">Client-Focused Approach</h3>
                <p className="why-choose-description">
                  We prioritize your needs and work closely with you to understand your business 
                  requirements and provide tailored solutions.
                </p>
              </div>
              <div className="why-choose-item">
                <h3 className="why-choose-title">Integrity and Transparency</h3>
                <p className="why-choose-description">
                  We maintain the highest standards of integrity and transparency in all our 
                  certification processes and interactions.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default AboutUs;

